export type RequirementTypeFormDataType = "string" | "boolean" | "selector";

export interface LocalRequirementType {
  localId: string;
  serverId?: number;
  serverDocumentId?: string;
  name: string;
  description: string;
  data_type: RequirementTypeFormDataType;
  required: boolean;
  access_key: boolean;
  transaction: boolean;
  selector_data: string[];
}

export const createEmptyLocalRequirementType = (
  localId: string,
): LocalRequirementType => ({
  localId,
  name: "",
  description: "",
  data_type: "string",
  required: false,
  access_key: false,
  transaction: true,
  selector_data: [""],
});
